export const FONTS_Poppins = "'Poppins', sans-serif";
export const FONTS_Montserrat = "'Montserrat', sans-serif";
export const FONTS_Playfair = "'Playfair Display', Georgia, 'Times New Roman', serif";

export default Object.freeze({
  MONT: "'Montserrat', sans-serif",
  POPP: "'Poppins', sans-serif",
  // Elegant serif display face for headings.
  SERIF: "'Playfair Display', Georgia, 'Times New Roman', serif",
});
